export default {
    setLoading(state,value){
        state.loading = value
    },
    setWishlist(state, items) {
        state.ids = items;
    },
    setUserId(state, userId) {
        state.userId = userId;
    },
    addWishlistId(state, id) {
        if (state.ids.findIndex((i) => parseInt(i) === id) === -1) {
            state.ids.push(id);
        }
    },
    removeWishlistId(state, id) {
        state.ids = state.ids.filter((i) => parseInt(i) !== id);
    },
};
